import type { ConceptDef } from '../types';

export const tactFoods: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-foods',
  label: 'Expressive Foods',
  category: 'Expressive',
  description: 'Show a food; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🍎 apple' },
      { prompt: '🍌 banana' },
      { prompt: '🍞 bread' },
      { prompt: '🧀 cheese' },
      { prompt: '🥕 carrot' },
      { prompt: '🍪 cookie' },
    ],
  },
};
